import StarRating from './StarRating'

interface StarRatingPopupProps {
  numOfStars: {
    '1_star': number
    '2_star': number
    '3_star': number
    '4_star': number
    '5_star': number
  }
  children: React.ReactNode
}

const StarRatingPopup = ({ numOfStars, children }: StarRatingPopupProps) => {
  return (
    <div className='relative group cursor-pointer'>
      {children}
      <div className='absolute z-10 hidden group-hover:flex flex-col gap-1 p-2 text-sm text-[#093269] bg-white rounded-md top-full left-1/2 -translate-x-1/2 mt-1 w-max shadow-md border'>
        {[...Array(5)].map((_, star) => (
          <div
            key={star}
            className='flex justify-between items-center gap-4 min-w-[200px] py-1'
          >
            <span className='whitespace-nowrap'>
              {numOfStars[`${star + 1}_star`]} reviews
            </span>
            <div className='flex gap-2'>
              <StarRating rating={star + 1} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default StarRatingPopup
